import { render, staticRenderFns } from "./RsaPaiRuoliListPage.vue?vue&type=template&id=629ba63c"
import script from "./RsaPaiRuoliListPage.vue?vue&type=script&lang=js"
export * from "./RsaPaiRuoliListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports